export const LOGIN_DATA = "LOGIN_DATA";